import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/years
    */
    getYears: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/years',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
        }});
    },

    /*
        GET     /api/years/search
    */
   searchYears: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/years/search',{
        params:{
            showDeleted:options.showDeleted,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

    /*
		POST 	/api/years
	*/
    postAddNewYear: function( name,from,to,holidays, _default ){
        return axios.post( LOGUS_CONFIG.API_URL + '/years',
            {
                name: name,
                from:from,
                to:to,
                holidays:holidays,
                default: _default,
            }
        );
    },

    /*
		GET 	/api/years/{slug}/edit
	*/
    getYearEdit: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/years/' + slug + '/edit' );
	},

    /*
		PUT 	/api/years/{slug}
	*/
    putEditYear: function(slug, name,from,to,holidays, _default){
        return axios.put( LOGUS_CONFIG.API_URL + '/years/'+ slug,
            {
                name: name,
                from:from,
                to:to,
                holidays:holidays,
                default: _default,
            }
        );
    },

     /*
		GET 	/api/years/reactivate/{slug}
	*/
    putReactivateYear: function(slug){
        return axios.get( LOGUS_CONFIG.API_URL + '/years/reactivate/' + slug);
    },

    /*
		DELETE /api/years/{slug}
	*/
    deleteYear: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/years/' + slug );
    },
    
    /*
		DELETE /api/years/{slug}/force
	*/
    forceDeleteYear: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/years/' + slug + '/force' );
	}
}